<div class="form-group">
  <label>Batching Type</label>
  <dx-lookup #artifactLookup
    [dataSource]="docConfigOutBatchers"
    [disabled]="!isEditing"
    [showClearButton]="true"
    [value]="selectedConfigOutBatcher"
    (onValueChanged)="artifactSelectedInternal($event)"
    [displayExpr]="displayExprBatcher">

    <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>

    <div *dxTemplate="let artifact of 'item'">
      <div class="the-grid">
        <div><p>{{artifact.ArtifactName}}</p></div>
      </div>
    </div>
  </dx-lookup>
</div>

@if (selectedConfigOutBatcher != null) {
  <div class="form-group">
    <label>Release Configuration</label>
    <dx-lookup #batchingConfigLookup
      [dataSource]="batchingConfigurations"
      [disabled]="!isEditing"
      [showClearButton]="true"
      [value]="selectedBatchingConfiguration"
      (onValueChanged)="batchConfigSelectedInternal($event)"
      [displayExpr]="displayExprBatchConfig">
      <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
      <div *dxTemplate="let config of 'item'">
        <div class="the-grid">
          <div><p>{{config.Name}}</p></div>
        </div>
      </div>
    </dx-lookup>
  </div>
}

@if (selectedConfigOutBatcher != null) {
  <div class="form-group">
    <label>Batching Filenaming</label>
    <select id="selectFilenaming" class="form-control"
      [ngModel]="$safeNavigationMigration(distribution?.BatchingFilenamingTypeId)"
      (ngModelChange)="distribution.BatchingFilenamingTypeId = $event">
      <option [ngValue]="null">None</option>
      @for (filenamingType of filenamingTypes | async; track filenamingType) {
        <option
          [ngValue]="filenamingType.FilenamingTypesId">
          {{filenamingType.FilenamingTypeName}}
        </option>
      }
    </select>
  </div>
}